import MobileVerificationModal from "./MobileVerificationModal"

export default MobileVerificationModal